import { getDateIncluded, getOffsetDate, databaseDate } from "@intrasync/utils";
import { RouteType } from "types/RouteType";
// import { utils } from '@intrasync/utils';
import { toJS } from "mobx";
import { ServiceStore } from "@intrasync/stores";
// import { getOffsetDate } from '@intrasync/utils';
// import IfcOverviewIcon from '@mui/icons-material/GridOn';
// import { toJS } from 'mobx';

type JobStat = {
  panelStatsTotal?: {
    startCasting?: string;
    endCasting?: string;
  };
  jobNumber?: number;
};

const ifcOverviewRoute: RouteType[] = [
  {
    name: "Production Schedule Overview",
    path: "/production-overview",
    layout: "/app",
    viewportCard: {
      header: {
        title: "Production Overview",
        component: () => import("./ProductionOverviewSchedule.Header"), // Assumed Header component exists
        enableRefreshButton: true,
        enableBackButton: true,
      },
      body: {
        // component: () => import('./IFCOverview.Body'),
        scheduleContainer: {
          namespace: "ProductionOverviewSchedule",
          storeName: "productionOverviewScheduleStore",
          dateKey: "jobNumber",
          dateRangeKey: "dateRange",
          fixedRowCount: 1,
          rowHeight: (rowIndex: { index: number }, rootStore) => {
            if (rowIndex.index === 0) {
              return 50;
            }
            if (!rootStore) {
              console.log("rootStore is undefined");
            }
            return 100;
          },
          // height: 500,
          // width: 500,
        },
      },
    },
    // icon: IfcOverviewIcon,

    dialogs: [
      {
        name: "setCapacity",
        title: "Set Daily Capacity",
        component: () =>
          import("../ProductionSchedule/ProductionSchedule.CapacityDialog"),
        cancelButton: false,
        height: 550,
      },
    ],
    hidden: true,
    defaultQueryParams: {
      startDate: getOffsetDate(databaseDate(), { offset: -14 }),
      endDate: getOffsetDate(databaseDate(), { offset: 56 }),
    },
    group: 'Scheduling',
  requiresAuth: true, // Assuming authentication is required
    requiresPermission: false,

    channels: [
      "dates/holidays",
      "job",
      "job",
      "ifc-status",
      "panel-revit",
      "panel-plant",
      "panel-yard",
      "hold",
      "job-stats/panel-count",
    ],
    enableAutoFind: false,
    beforeEnter: async ({ rootStore }) => {
      const datesHolidaysStore = rootStore.datesHolidaysStore as ServiceStore;
      const jobStore = rootStore.jobStore as ServiceStore;
      const holdStore = rootStore.holdStore as ServiceStore;
      const jobStatsPanelCountStore =
        rootStore.jobStatsPanelCountStore as ServiceStore;
      const manhourCapacityStore = rootStore.manhourCapacityStore as ServiceStore;

      jobStatsPanelCountStore.find();
      datesHolidaysStore.find();
      jobStore.find();
      holdStore.find({
        query: {
          $limit: 2000,
        },
      });
      // Load manhour capacity standards
      manhourCapacityStore.find({
        query: {
          $sort: { effectiveDate: -1 },
        },
      });

      return true;
    },
    onEnter: async ({ rootStore, queryParams }) => {
      const jobStatsCastingDatesStore =
        rootStore.jobStatsCastingDatesStore as ServiceStore;

      const { startDate, endDate } = toJS(queryParams);

      const foundJobStats = await jobStatsCastingDatesStore.find();

      const foundJobStatsData = foundJobStats?.data as JobStat[];

      const jobInRange = foundJobStatsData.reduce((acc: number[], jobStat) => {
        let shouldInclude = false;
        if (
          jobStat?.panelStatsTotal?.startCasting &&
          jobStat?.panelStatsTotal?.endCasting
        ) {
          const checkIfStartIncluded = getDateIncluded(
            startDate as string,
            jobStat?.panelStatsTotal?.startCasting,
            jobStat?.panelStatsTotal?.endCasting
          );

          if (checkIfStartIncluded) {
            shouldInclude = true;
          }

          const checkIfEndIncluded = getDateIncluded(
            endDate as string,
            jobStat?.panelStatsTotal?.startCasting,
            jobStat?.panelStatsTotal?.endCasting
          );
          if (checkIfEndIncluded) {
            shouldInclude = true;
          }
        }

        if (shouldInclude) {
          acc.push(jobStat.jobNumber as number);
        }
        return acc;
      }, []);
      // console.log('Included Jobs', jobInRange);
      if (jobInRange.length) {
        const ifcStatusStore = rootStore.ifcStatusStore as ServiceStore;
        const panelStore = rootStore.panelStore as ServiceStore;
        // const panelStore = rootStore.panelStore as ServiceStore;
        // const panelStore = rootStore.panelStore as ServiceStore;
        // console.log('Included Jobs', jobInRange);
        for (const jobNumber of jobInRange) {
          // console.log('Job Number', jobNumber);
          ifcStatusStore.find({
            query: {
              jobNumber: jobNumber,
              $limit: 2000,
            },
          });
          panelStore.find({
            query: {
              jobNumber: jobNumber,
              $limit: 2000,
            },
          });
          await new Promise((resolve) => setTimeout(resolve, 1000));
        }
      }
    },

    onParamsChange: async ({ rootStore, queryParams, previousQueryParams }) => {
      if (previousQueryParams !== queryParams) {
        console.log("trigger enter effects");
        rootStore.routerStore?.triggerEnterSideEffects();
      }
    },
  },
];

export default ifcOverviewRoute;
